import sentGAEvent from ".";
/**
 * 登录页面出现曝光埋点
 */
const GALoginPageDisplay = () => {
    sentGAEvent({
        category: "login",
        action: "login_display",
    });
};

/**
 * 点击登录按钮
 * @param {string} label
 */
const GALoginClickConfirm = label => {
    sentGAEvent({
        category: "login",
        action: "login_confirm_click",
        label,
    });
};

/**
 * 登录表单格式报错
 * @param {string} label
 */
const GALoginFromError = label => {
    sentGAEvent({
        category: "login",
        action: "login_error",
        label,
    });
};

/**
 * 登录页面跳转sign up页面
 */
const GALoginClickToSignUp = () => {
    sentGAEvent({
        category: "login",
        action: "login_to_sign",
    });
};

//跳转设置密码页面
const GALoginClickToSetPassowrd = () => {
    sentGAEvent({
        category: "login",
        action: "login_to_setpassword",
    });
};


export {
    GALoginPageDisplay,
    GALoginClickConfirm,
    GALoginFromError,
    GALoginClickToSignUp,
    GALoginClickToSetPassowrd
};